import { EntityTypes } from 'constants/entities';
import { IHistoryItem, IRegisterReducer } from 'core/slices/register';
import { ISessionReducer, Mode } from 'core/slices/session';
import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { selectSession } from './session';

const register = (state: RootState) => state.register;
const courseProgressId = (state: RootState) => state.state[EntityTypes.COURSE_PROGRESS];
const sessionAttemptId = (state: RootState) => state.state[EntityTypes.SESSION_ATTEMPT];
const session = selectSession;

export const selectHistory = createSelector([session, register, courseProgressId, sessionAttemptId], parseHistory);

export function parseHistory(
  session: ISessionReducer,
  register: IRegisterReducer,
  courseProgressId: number,
  sessionAttemptId: number,
) {
  const filter = (item: IHistoryItem) => {
    if (session.mode === Mode.PREVIEW)
      return item.sessionAttemptId === sessionAttemptId || item.courseProgressId === courseProgressId;
    else return true;
  };

  return register.history.filter(filter);
}
